<script setup lang="ts">
	import { vOnClickOutside } from "@vueuse/components";
	import { X } from "lucide-vue-next";
	import BackIcon from "public/images/back.svg";

	const title = ref<string>();
	const text = ref<string | undefined>();
	const onClose = ref(() => {});
	const onAction = ref<undefined | (() => Promise<void>)>(undefined);
	const closeOnAction = ref<boolean>(true);
	const onBack = ref<undefined | (() => Promise<void>)>(undefined);
	const show = ref<boolean>(false);
	const showClose = ref(false);
	const actionText = ref("تایید");

	defineExpose({
		title,
		text,
		onClose,
		onAction,
		onBack,
		closeOnAction,
		show,
		showClose,
		actionText,
	});

	const close = async () => {
		show.value = false;
		text.value = undefined;
		await onClose.value();
	};

	const action = async () => {
		if (closeOnAction.value) {
			show.value = false;
			text.value = undefined;
		}
		if (onAction.value) await onAction.value();
	};
</script>

<template>
	<Teleport v-if="show" to="#teleports">
		<form novalidate @submit.prevent="action()">
			<div class="z-50 fixed inset-0 bg-black opacity-30"></div>
			<div
				class="fixed inset-0 z-50 flex place-content-center justify-center items-center"
			>
				<div
					v-on-click-outside="async (_) => await close()"
					class="justify-self-center gap-4 self-end w-full md:place-self-center flex flex-col bg-white text-black shadow-xl rounded-t-2xl md:rounded-b-2xl p-4 h-max md:w-fit min-w-80 md:max-w-96"
				>
					<div class="flex flex-row font-medium justify-between">
						<BackIcon v-if="onBack" @click="onBack" />
						<h3>{{ title }}</h3>
						<X
							class="cursor-pointer w-6 h-6 font-semibold"
							@click="close"
						/>
					</div>
					<div v-if="text">
						<p class="leading-relaxed text-justify">{{ text }}</p>
					</div>
					<slot v-else name="body"></slot>
					<div
						class="flex flex-row justify-between md:justify-start gap-4"
					>
						<button
							v-if="onAction"
							class="min-h-0 h-btn border-0 btn bg-primary rounded-full w-[calc(50%-8px)] text-white hover:bg-primaryHover font-medium"
							:class="{
								'w-32': showClose,
								'w-full': !showClose,
							}"
							type="submit"
						>
							{{ actionText }}
						</button>
						<button
							v-if="showClose"
							type="button"
							class="whitespace-nowrap z-20 min-h-0 h-btn w-[calc(50%-8px)] btn text-primary border border-primary px-6 py-2 rounded-full hover:bg-gray-300 flex items-center gap-2 bg-white transition-colors"
							@click="close"
						>
							انصراف
						</button>
					</div>
				</div>
			</div>
		</form>
	</Teleport>
</template>

<style scoped></style>
